module.exports = __webpack_public_path__ + "media/images/pc/top/record_deco-f414d09dba391d30867c98f30c09c334.svg";